import { gql } from "@apollo/client";

export const CHATBOT_CONVERSATION_UPDATED = gql`
  subscription chatbotConversationUpdated($mainSuperAdminId: Int!) {
    chatbotConversationUpdated(mainSuperAdminId: $mainSuperAdminId) {
      id
      conversationId
      customerName
      lastMessage
      status
      updatedAt
      endedAt
      messageCount
      avgConfidence
      handedOffToAgentId
      agent {
        id
        name
        designation {
          id
          paneltype
        }
      }
      bot {
        name
      }
      labels
      read
    }
  }
`;

export const CHATBOT_MESSAGE_ADDED = gql`
  subscription chatbotMessageAdded($conversationId: String!) {
    chatbotMessageAdded(conversationId: $conversationId) {
      id
      messageId
      role
      content
      fileUrl
      fileType
      confidenceScore
      createdAt
    }
  }
`;

export const CHATBOT_MESSAGE_DELETED = gql`
  subscription chatbotMessageDeleted($conversationId: String!) {
    chatbotMessageDeleted(conversationId: $conversationId)
  }
`;
